import React, { FC, Fragment } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { User } from 'models/user';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import ClientDirectoryDentistItem from './client-directory-dentist-item.component';
import useFixMissingScroll from 'utils/use-fix-missing-scroll';
import { useNavigate } from 'react-router-dom';

type ClientDirectoryDentistListProps = {
    isWhiteLabel?: boolean;
    showDefaultClinicColumn?: boolean;
    filteredDentists: User[];
    clientId: string;
    onFetchMore: () => void;
    onUserUpdated: (user: User) => void;
};
const ClientDirectoryDentistList: FC<ClientDirectoryDentistListProps> = ({
    isWhiteLabel,
    showDefaultClinicColumn,
    filteredDentists,
    clientId,
    onFetchMore,
    onUserUpdated,
}: ClientDirectoryDentistListProps) => {
    const { t: translate } = useTranslation(['common', 'client-directory', 'users']);
    const navigate = useNavigate();

    const handleUpdateDentist = (dentist: User) => {
        const params = new URLSearchParams({ clinicId: clientId });
        if (isWhiteLabel) params.set('whiteLabel', 'true');
        navigate(`/client-directory/dentists/${dentist._id}/dentist-details?${params.toString()}`);
    };

    // Fix for infinite scroll not working on some screen sizes.
    useFixMissingScroll(onFetchMore, filteredDentists?.length || 0);

    return (
        <Fragment>
            <TableContainer>
                <InfiniteScroll
                    dataLength={filteredDentists ? filteredDentists.length : 0}
                    next={onFetchMore}
                    throttleTimeInMs={75}
                    hasMore={true}
                    loader={undefined}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{translate('common:STATUS')}</TableCell>
                                {isWhiteLabel ? (
                                    <TableCell>{translate('client-directory:MY_PAGES')}</TableCell>
                                ) : undefined}
                                <TableCell>{translate('common:NAME')}</TableCell>
                                <TableCell>{translate('common:EMAIL')}</TableCell>
                                {showDefaultClinicColumn ? (
                                    <TableCell>{translate('users:DEFAULT_CLINIC')}</TableCell>
                                ) : undefined}
                                <TableCell>{translate('common:ROLE')}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDentists && (
                                <Fragment>
                                    {filteredDentists.map((dentist: User) => (
                                        <ClientDirectoryDentistItem
                                            key={dentist._id}
                                            isWhiteLabel={isWhiteLabel}
                                            showDefaultClinicColumn={showDefaultClinicColumn}
                                            mainClinicId={clientId}
                                            dentist={dentist}
                                            onUpdateDentist={handleUpdateDentist}
                                            onUserUpdated={onUserUpdated}
                                        />
                                    ))}
                                </Fragment>
                            )}
                        </TableBody>
                    </Table>
                </InfiniteScroll>
            </TableContainer>
        </Fragment>
    );
};

export default ClientDirectoryDentistList;
